import SignUpLayoutBox from './SignUpLayoutBox'

export default SignUpLayoutBox
